import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import { Card, Flex, Header, Icon, Link, Table, TableColumn, Tooltip } from '@driftt/dds'
import { faUserGroup } from '@driftt/dds.icons/light/faUserGroup'

import { useTopVisitors } from 'hooks/useTopVisitors'
import { ContactWithActivites } from 'modules/accountActivity/domain'
import { segmentTrack, TrackType } from 'utils/tracking'

export interface TopVisitorsProps {
  accountId: string
}

const tableColumns: TableColumn<ContactWithActivites>[] = [
  {
    value: 'endUserData',
    header: 'NAME',
    size: 220,
    disableSort: true,
    cell: ({ endUserData: { name, email, id } }) => {
      return (
        <Tooltip content={name || email}>
          <Link
            as={RouterLink}
            css={{ maxWidth: '190px' }}
            truncate
            variant="inline"
            to={`/activity/contacts/${id}`}
            target="_blank"
            onClick={() =>
              segmentTrack(TrackType.ACCOUNT_DETAILS_TOP_VISITORS_NAVIGATES_TO_CONTACT_PAGE)
            }>
            {name || email}
          </Link>
        </Tooltip>
      )
    }
  },
  {
    id: 'activityCount',
    header: 'VISITS',
    disableSort: true,
    value: 'activityCount',
    align: 'right',
    size: 70
  }
]

const TopVisitors = ({ accountId }: TopVisitorsProps) => {
  const topVisitorsList = useTopVisitors(accountId)

  if (!topVisitorsList.length) {
    return null
  }

  return (
    <Card css={{ padding: '18px 0px 0px 0px', marginBottom: '$2' }}>
      <Card.Header as={Flex} gap="half" alignItems="center" css={{ padding: '0px 10px' }}>
        <Icon
          css={{
            color: 'white',
            padding: '3px',
            borderRadius: '3px',
            fontSize: '$2',
            marginRight: '4px',
            backgroundColor: '$teal6'
          }}
          icon={faUserGroup}
          size="large"
        />
        <Header variant="h4">TOP VISITORS</Header>
      </Card.Header>
      <Card.Content>
        <Table
          rows={topVisitorsList}
          columns={tableColumns}
          disableBoxShadow={true}
          emptyState={{
            title: 'No data available',
            subtitle: '',
            minHeight: 200
          }}
        />
      </Card.Content>
    </Card>
  )
}

export default TopVisitors
